/*
 * @Author: bz2021
 * @Date: 2025-07-01 20:16:40
 * @Description:  
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Layout, Button, Input, Space, message, Radio, Select } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone, UserOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { register } from '../../api/auth';
import request from '../../utils/request';

const { Header, Footer, Sider, Content } = Layout;
const { Option } = Select;

const headerStyle = {
    textAlign: 'center',
    color: '#fff',
    height: 64,
    paddingInline: 48,
    lineHeight: '64px',
    backgroundColor: '#ED4948',
};
const contentStyle = {
    textAlign: 'center',
    padding: '10px',
    minHeight: 120,
    lineHeight: '35px',
    color: '#000',
};
const footerStyle = {
    textAlign: 'center',
    color: '#fff',
    backgroundColor: '#4096ff',
};

const Register = () => {
    const [loading, setLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = React.useState(false);
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        email: '',
        verify_code: '',
        master_id: '',
        registerType: 'admin',
    });
    const [countdown, setCountdown] = useState(60);
    const [isCounting, setIsCounting] = useState(false);
    const [admins, setAdmins] = useState([]);
    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        if (formData.registerType === 'customer') {
            fetchAdmins();
        }
    }, [formData.registerType]);

    const fetchAdmins = async () => {
        try {
            const response = await request('/master');
            const adminList = response.data || [];
            setAdmins(adminList);
            if (adminList.length > 0) {
                setFormData(prev => ({ ...prev, master_id: Number(adminList[0].id) }));
            }
        } catch (error) {
            messageApi.error('获取管理员列表失败');
        }
    };

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleRegisterTypeChange = (e) => {
        setFormData(prev => ({ ...prev, registerType: e.target.value }));
    };

    const handleMasterChange = (value) => {
        setFormData(prev => ({ ...prev, master_id: value }));
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        try {
            // 客户注册需要验证master_id
            if (formData.registerType === 'customer' && !formData.master_id) {
                messageApi.error('请选择管理员');
                setLoading(false);
                return;
            }
            if (formData.registerType !== 'customer') {
                formData.master_id = 0
            }
            // 验证验证码
            if (!formData.verify_code) {
                messageApi.error('请输入验证码');
                setLoading(false);
                return;
            }
            await register(formData);
            messageApi.success('注册成功');
            navigate('/login');
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    messageApi.error(`参数校验失败: ${error.response.data.msg}`);
                } else {
                    messageApi.error(`请求失败，状态码: ${error.response.status}, ${error.response.data.msg}`);
                }
            } else if (error.request) {
                messageApi.error('网络错误，请检查网络连接');
            } else {
                messageApi.error('请求错误: ' + error.message);
            }
            console.error('注册失败:', error);
        }
        setLoading(false);
    };

    const sendverify_code = async () => {
        if (!formData.email) {
            messageApi.error('请先输入邮箱');
            return;
        }
        try {
            setIsCounting(true);
            setCountdown(60);
            await request.post(`/send_verify_code?email=${formData.email}`);
            messageApi.success('验证码发送成功');
            const timer = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setIsCounting(false);
                        return 60;
                    }
                    return prev - 1;
                });
            }, 1000);
        } catch (error) {
            messageApi.error('验证码发送失败');
            setIsCounting(false);
        }
    };

    return (
        <div>
            {contextHolder}
            <Header style={headerStyle}>注册</Header>
            <Content style={contentStyle}>
                <Space direction="vertical">
                    <Radio.Group
                        onChange={handleRegisterTypeChange}
                        value={formData.registerType}
                    >
                        <Radio value="admin">管理注册</Radio>
                        <Radio value="customer">客户注册</Radio>
                    </Radio.Group>
                    <Input placeholder="请输入用户名"
                        prefix={<UserOutlined />}
                        value={formData.username}
                        name="username"
                        onChange={handleChange}
                    />
                    <Input.Password
                        placeholder="请输入密码（至少 6 位）"
                        visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
                        value={formData.password}
                        name="password"
                        onChange={handleChange}
                    />
                    <Input placeholder="请输入邮箱"
                        prefix={<MailOutlined />}
                        value={formData.email}
                        name="email"
                        onChange={handleChange}
                    />
                    <Space.Compact style={{ width: '100%' }}>
                        <Input 
                            placeholder="请输入验证码"
                            value={formData.verify_code}
                            name="verify_code"
                            onChange={handleChange}
                        />
                        <Button 
                            onClick={sendverify_code} 
                            disabled={isCounting}
                        >
                            {isCounting ? `${countdown}秒后重新发送` : '发送验证码'}
                        </Button>
                    </Space.Compact>
                    {formData.registerType === 'customer' && (
                        <Select
                            placeholder="请选择管理员"
                            onChange={handleMasterChange}
                            value={formData.master_id}
                            style={{ width: '100%' }}
                        >
                            {admins.map(admin => (
                                <Option key={admin.id} value={admin.id}>
                                    {admin.username}
                                </Option>
                            ))}
                        </Select>
                    )}
                    <Button 
                        style={{ background: '#ED4948', color: '#fff' }} 
                        variant="solid" block
                        onClick={handleSubmit}
                        loading={loading}
                    >
                        注册
                    </Button>
                    <Button 
                        style={{ color: '#ED4948' }}
                        variant="solid" block
                        onClick={() => navigate('/login')}
                    >
                        返回登录
                    </Button>
                </Space>
            </Content>
            {/* <Footer style={footerStyle}>Footer</Footer> */}
        </div>
    );
};

export default Register;